/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { GmcError } from '@app/core/types';
import { createAction, props } from '@ngrx/store';
import { NodeId } from '@shared/types/node';

export const getNodeConfigurationErr = createAction('[Node] Get Configuration Failure', props<GmcError>());

export const getThreadDumpErr = createAction('[Node] Get thread dump error', props<GmcError>());

export const triggerNodeGarbageCollection = createAction('[Node] Trigger GC', props<{ nodeId: NodeId }>());
export const triggerNodeGarbageCollectionOK = createAction('[Node] Trigger GC OK', props<{ notification?: string }>());
export const triggerNodeGarbageCollectionErr = createAction('[Node] Trigger GC Err', props<GmcError>());
